import type { TextGetterProps } from '@ui-kit/components/formComponents/RadioCardSet/RadioCard/types'
import type { LayoutType } from '@ui-kit/components/formComponents/RadioCardSet/types'

interface UseTextProps {
  layout: LayoutType
  isSmallDevice: boolean
  disabled: boolean | undefined
  isSelected: boolean
}

export const useTextProps = (props: UseTextProps) => {
  const getTitleProps = (): TextGetterProps => {
    if (props.isSelected) {
      return {
        emphasis: props.disabled ? 'low' : undefined,
        align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'left',
        bold: true,
      }
    }

    return {
      emphasis: props.disabled ? 'low' : undefined,
      align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'left',
      bold: undefined,
    }
  }

  const getSubtitleProps = (): TextGetterProps => {
    if (props.isSelected) {
      return {
        emphasis: props.disabled ? 'low' : undefined,
        align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'right',
        bold: true,
      }
    }

    return {
      emphasis: props.disabled ? 'low' : 'medium',
      align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'right',
      bold: undefined,
    }
  }

  const getDescriptionsProps = (): TextGetterProps => {
    return {
      emphasis: props.disabled ? 'low' : 'medium',
      align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'left',
      bold: undefined,
    }
  }

  return { getTitleProps, getSubtitleProps, getDescriptionsProps }
}
